import { SIDELOADED_DATA_MAPPING } from "constants/actionTypes";

import { offlineCrudReducer } from "lib/reducers";
import { deserializeSideLoadedDataMapping } from "lib/serializers/sideLoadedDataMappings";

const sideLoadedDataMappings = offlineCrudReducer(SIDELOADED_DATA_MAPPING, {
  deserializer: deserializeSideLoadedDataMapping,
});

export default sideLoadedDataMappings;
